import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import NewLiveData from './NewLiveData.vue';
import OldLiveData from './OldLiveData.vue';
import Crumb from '@/components/Crumb.vue';
import { useLiveStore } from '@/pinia/live';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveData',
  setup(__props) {

const liveInfo = useLiveStore();
const data_page_rout = computed(() => liveInfo.liveInfo?.data_page_rout);

const cutVersion = () => {
  liveInfo.liveInfo.data_page_rout = Number(!liveInfo.liveInfo?.data_page_rout);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb, null, {
      title: _withCtx(() => [
        _createTextVNode(" 直播数据 ")
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_unref(data_page_rout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(NewLiveData, { "onClick:cutVersion": cutVersion })
          ]))
        : _createCommentVNode("", true),
      (!_unref(data_page_rout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(OldLiveData, { "onClick:cutVersion": cutVersion })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})